import {ReactComponent as ArrowRight} from '@/assets/icons/arrow.svg';
import {ReactComponent as ChevronLeft} from '@/assets/icons/chevron-left.svg';
import {ReactComponent as ChevronRight} from '@/assets/icons/chevron-right.svg';
import {ReactComponent as Info} from '@/assets/icons/info.svg';

const Icons = {
    'arrow-right': ArrowRight,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'info': Info,
}

export default function Icon ({icon, size = 24}) {
    const IconElement = Icons[icon];
    
    return IconElement ? <IconElement width={size} height={size} /> : null;
}
